// todo BUILD-2130 - import the types when the pipeline is corrected
// import { type Types } from '@usealloy/api-contract';
// type J = Types['Typhon']['Journeys'];

import type { APIClient } from '../../apiClient';
import { journeyRoutes } from './journeyRoutes';


export default function createJourneysAPI(apiClient: APIClient) {
  return {
    // todo BUILD-2130 - use the import the types when the pipeline is corrected
    create: (data: any) => apiClient.post(journeyRoutes.root, data),
    get: (params: { journeyToken: string }) => (
      // todo BUILD-2130 - use the import the types when the pipeline is corrected
      apiClient.get(journeyRoutes.journey(params.journeyToken))
    ),
  };
}
